import { useLanguage } from "@/i18n/LanguageContext";
import lierac from "@/assets/brands/lierac.webp";
import soraya from "@/assets/brands/soraya.webp";
import bielenda from "@/assets/brands/bielenda.webp";
import dermika from "@/assets/brands/dermika.webp";
import skinarte from "@/assets/brands/skinarte.webp";
import sugarbearhair from "@/assets/brands/sugarbearhair.webp";
import frudia from "@/assets/brands/frudia.webp";
import sheaMoisture from "@/assets/brands/shea-moisture.webp";

const brands = [
  { name: "Lierac", src: lierac },
  { name: "Soraya", src: soraya },
  { name: "Bielenda", src: bielenda },
  { name: "Dermika", src: dermika },
  { name: "SkinArté", src: skinarte },
  { name: "Shea Moisture", src: sheaMoisture },
  { name: "SugarBearHair", src: sugarbearhair },
  { name: "Frudia", src: frudia },
];

const BrandCarousel = () => {
  const { t, lang } = useLanguage();
  const fontFamily = lang === "ar" ? "'Noto Sans Arabic', 'Nunito', sans-serif" : "'Nunito', sans-serif";
  const repeated = [...brands, ...brands, ...brands, ...brands];

  return (
    <section className="overflow-hidden bg-white py-5">
      <p
        className="mb-6 text-center text-[11px] font-semibold uppercase tracking-[0.35em] text-neutral-500"
        style={{ fontFamily }}
      >
        {t("brands.trustedBy")}
      </p>

      <div className="relative w-full">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />

        <div className="flex w-max animate-[scroll_30s_linear_infinite] items-center gap-16">
          {repeated.map((brand, i) => (
            <img
              key={`${brand.name}-${i}`}
              src={brand.src}
              alt={brand.name}
              className={`${brand.name === "Soraya" ? "h-6" : brand.name === "Lierac" ? "h-7" : brand.name === "Shea Moisture" ? "h-8" : "h-10"} w-auto object-contain grayscale opacity-60 transition-all duration-300 hover:grayscale-0 hover:opacity-100`}
              draggable={false}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;
